var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, alias1=this.lambda;

  return "<div\r\n    id=\""
    + ((stack1 = alias1((depth0 != null ? depth0.containerElementId : depth0), depth0)) != null ? stack1 : "")
    + "\"\r\n    data-announcement-name=\""
    + this.escapeExpression(alias1(((stack1 = (depth0 != null ? depth0.announcement : depth0)) != null ? stack1.name : stack1), depth0))
    + "\"\r\n    class=\"OffscreenContainer\"\r\n>\r\n    "
    + ((stack1 = alias1((depth0 != null ? depth0.html : depth0), depth0)) != null ? stack1 : "")
    + "\r\n</div>";
},"useData":true});